<h2 class="section-title">{{sectionInfo.title}}</h2>
<h3 class="medium-gray-title margin-top-sm">{{sectionInfo.subtitle}}</h3>
<span class="post-horizontal rounded" *ngFor="let item of sectionInfo.array">
    <div class="flex-col">
        <p>{{item.description}}</p>
        <a *ngIf="item.link" [href]="item.link" class="link" target="_blank">Link</a>
    </div>
</span>